<template>
    <div
          tabindex="-1"
          class="el-image-viewer__wrapper"
          style="z-index: 1300001"
        >
          <div class="el-image-viewer__mask" @click="closeImageViewer" />
          <div class="el-image-viewer__canvas">
            <img
              :src="imageViewerUrl"
              class="el-image-viewer__img"
              style="
                transform: scale(1) rotate(0deg);
                margin-left: 0px;
                margin-top: 0px;
                max-height: 100%;
                max-width: 100%;
              "
            />
          </div>
        </div>
</template>
<script>
export default {
    props:{
        imageViewerUrl:{
            type: String,
            default: ''
        }
    },
    methods:{
        closeImageViewer(){
            this.$emit("closeImageViewer",null)
        }
    }
}
</script>